export const circularProgressStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
}
